// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"7b66e22c","453":"0ba86d28","482":"a6711a5a","685":"0313f7bd","712":"43018eaa","821":"e279d7ef","835":"15e1f365","928":"9ed52a72"}[chunkId] + ".chunk.js";
};